import React from "react";
import { Clock, Edit3 } from "lucide-react";
import { formatDiagnosticDate } from "../../../utils/dateFormatter";

function SystemStatus({ diagnosticData }) {
   // Extract and format the SystemTimestamp safely
   const systemTimestamp = formatDiagnosticDate(diagnosticData?.systemStatus[0]?.SysTimestamp);
   const Modificationdate = formatDiagnosticDate(diagnosticData?.systemStatus[0]?.modifiedDate);
  
  return (
    <div className="space-y-4">
      {/* System Time Section */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Clock className="text-blue-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">Last Updated Date</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-gray-700 bg-gray-50 text-sm font-medium">
          {systemTimestamp}
        </div>
      </div>

      {/* Date of Modification Section */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-green-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Edit3 className="text-green-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">Last System Restart time</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-gray-700 bg-gray-50 text-sm font-medium">
          {Modificationdate}
        </div>
      </div>

    </div>
  );
}

export default SystemStatus;

